module.exports = __webpack_public_path__ + "img/arrow-down.ab31846.svg";